module.exports = __webpack_public_path__ + "img/4.2a0b00c4.jpg";